import Calendar from "./calendar/Calendar";
import Gallery from "./gallery/Gallery";
import HomeSection from "./home-section/HomeSection";
import MainText from "./main-text/MainText";
import ScrollToTop from "./scroll-to-top/ScrollToTop";
import SecondaryText from "./secondary-text/SecondaryText";
import Social from "./social/Social";
import Team from "./team/Team";
import Video from "./video/Video";

export default function Home() {
    return (
        <>
            <HomeSection />
            <Video />
            <MainText />
            <SecondaryText />
            <Team />
            <Calendar />
            <Social />
            <Gallery />
            <ScrollToTop />
        </>
    )
}